import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../layouts/PublicLayout';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

function MessageForm(): ReactElement {
    const { t, i18n } = useTranslation('messageForm');
    const metaTitle = t('meta.title');
    const iframeTitle = t('iframeTitle');
    const backToDesk = t('backToDesk');

    const lang = (i18n.language || 'ja').split('-')[0];
    const formUrl =
        lang === 'en'
            ? (import.meta.env.VITE_CONTACT_FORM_URL_EN as string) ||
              'https://docs.google.com/forms/d/e/1FAIpQLSfohdFJL4wLMW-LWWz8TQAfhS2VSawXrjMsqIGP_nXPJHgCyg/viewform?embedded=true'
            : (import.meta.env.VITE_CONTACT_FORM_URL_JA as string) ||
              'https://docs.google.com/forms/d/e/1FAIpQLSeWUkFikpnUitdwk8D0K0_l1qlNjyXMO7YCi2MJe7Vam_Zqhw/viewform?embedded=true';

    // Google Forms のUI言語を強制（hlパラメータ）
    const formUrlWithLocale = (() => {
        try {
            const url = new URL(formUrl);
            url.searchParams.set('hl', lang === 'en' ? 'en' : 'ja');
            return url.toString();
        } catch {
            // URLのパースに失敗した場合は元URLを返す
            return formUrl;
        }
    })();

    return (
        <PublicLayout>
            <Helmet>
                <title>{metaTitle}</title>
            </Helmet>

            <div className="w-full max-w-4xl mx-auto px-4 py-8">
                <div className="mt-10">
                    {/* メッセージフォーム */}
                    <iframe
                        title={iframeTitle}
                        src={formUrlWithLocale}
                        className="w-full h-[900px]"
                        frameBorder={0}
                        marginHeight={0}
                        marginWidth={0}
                    >
                        Loading…
                    </iframe>

                    {/* デスクへボタン */}
                    <div className="text-center my-10">
                        <Link to="/desk">
                            <button
                                type="button"
                                className="inline-block px-8 py-3 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors duration-200 w-full max-w-md"
                            >
                                {backToDesk}
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </PublicLayout>
    );
}

export default MessageForm;
